import React from "react";
import { CardContent, Typography, Box, Stack } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";

function Inventory({ response }) {
  return (
    <>
      <StyledCard variant="outlined">
        <CardContent>
          <Typography
            mb={1.5}
            variant="h5"
            fontWeight={700}
            color={"text.primary"}
          >
            Inventory
          </Typography>
          <Stack direction={"row"} alignItems={"center"}>
            <Box>
              <Typography mb={1} color={"text.primary"}>
                FEMS-Mec
              </Typography>
              <Typography
                variant="h1"
                fontWeight={700}
                color={"success.dashboard"}
              >
                {response?.totalFEMSMecCount}
              </Typography>
            </Box>
            <Box ml={3}>
              <Typography mb={1} color={"text.primary"}>
                FEMS-Elec
              </Typography>
              <Typography
                variant="h1"
                fontWeight={700}
                color={"warning.dashboard"}
              >
                {response?.totalFEMSElecCount}
              </Typography>
            </Box>
            <Box ml={3}>
              {" "}
              <Typography mb={1} color={"text.primary"}>
                FEMS-Civil
              </Typography>
              <Typography
                variant="h1"
                fontWeight={700}
                color={"text.secondary"}
              >
                {response?.totalFEMSCivilCount}
              </Typography>
            </Box>
            <Box ml={3}>
              <Typography mb={1} color={"text.primary"}>
                BEMS
              </Typography>
              <Typography
                variant="h1"
                fontWeight={700}
                color={"info.dashboard"}
              >
                {response?.totalBEMSitemCount}
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default Inventory;
